export enum FontSizeToken {
  micro = '1.2rem',
  small = '1.4rem',
  medium = '1.6rem',
  large = '1.8rem',
  xLarge = '2rem',
  xXLarge = '2.4rem',
  huge = '3rem',
  xHuge = '3.6rem',
  xXHuge = '4.8rem',
  giant = '6rem',
  display = '7.2rem',
}

export default FontSizeToken

export type TFontSize =
  | 'micro'
  | 'small'
  | 'medium'
  | 'large'
  | 'xLarge'
  | 'xXLarge'
  | 'huge'
  | 'xHuge'
  | 'xXHuge'
  | 'giant'
  | 'display '
